import { PaysafeField } from "@modules/paysafe/models/paysafe-field";
import { CC_BRAND, VALID_CC_BRAND } from "@modules/paysafe/models/paysafe-config";

export class PaysafeCreditCardNumberField extends PaysafeField {
	public constructor(
		name: string,
		errorMsg: string,
		private errorIfCardValid: string,
		private supportedCardBrands: VALID_CC_BRAND[]
	) {
		super(name, errorMsg);
	}

	protected _creditCardType: CC_BRAND;

	public get creditCardType(): string {
		return this._creditCardType;
	}

	protected _cardBrandValid: boolean;

	public get cardBrandValid(): boolean {
		return this._cardBrandValid;
	}

	public get secondaryErrorI18nKey(): string {
		return this.errorIfCardValid;
	}

	public setErrorMsg(errorMsg: string): void {
		this.errorMsg = errorMsg;
	}

	public setSupportedCardBrands(brands: VALID_CC_BRAND[]): void {
		this.supportedCardBrands = brands;
	}

	protected onFieldValueChange = (eventInstance, event): void => {
		this.isEmpty = event.data.isEmpty;
		if (!eventInstance.fields.cardNumber.isEmpty() && eventInstance.getCardBrand()) {
			let cardBrand = eventInstance.getCardBrand().replace(/\s+/g, "");
			this._creditCardType = cardBrand.toLowerCase();
		} else {
			this._creditCardType = "unknown";
		}
		this.checkCardBrand();
	};

	protected setValid(status: boolean): void {
		this.isValid = status && this._cardBrandValid;
		this._isValid.next(this.isValid);
		this._setColor(this.isValid);
	}

	private checkCardBrand(): void {
		this._cardBrandValid = this.supportedCardBrands.includes(this._creditCardType as VALID_CC_BRAND);
	}
}
